import { sortComparator } from './helpers';
import camelcaseKeys from 'camelcase-keys';

// Both V3 and V4 inboxes render every item as a conversation (routing/marking-as-read by
// primary-actor id), so only conversation actors belong in these lists. Other actors (e.g.
// AgentExecutionReport alerts) remain visible via the bell/notifications page.
const filterSortedConversationNotifications = ($state, filters) => {
  const sortOrder = filters.sortOrder === 'desc' ? 'newest' : 'oldest';
  return Object.values($state.records)
    .filter(notification => notification.primary_actor_type === 'Conversation')
    .sort((n1, n2) => sortComparator(n1, n2, sortOrder));
};

export const getters = {
  getNotifications($state) {
    return Object.values($state.records).sort((n1, n2) => n2.id - n1.id);
  },
  getFilteredNotifications: $state => filters => {
    return filterSortedConversationNotifications($state, filters);
  },
  getFilteredNotificationsV4: $state => filters => {
    return camelcaseKeys(
      filterSortedConversationNotifications($state, filters),
      {
        deep: true,
      }
    );
  },
  getNotificationById: $state => id => {
    return $state.records[id] || {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getNotification: $state => id => {
    const notification = $state.records[id];
    return notification || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
  getNotificationFilters($state) {
    return $state.notificationFilters;
  },
  getHasUnreadNotifications: $state => {
    return $state.meta.unreadCount > 0;
  },
  getUnreadCount: $state => {
    return $state.meta.unreadCount;
  },
};
